// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let React = require("react");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let NotificationCount = require("./NotificationCount.bs.js");
let JsxRuntime = require("react/jsx-runtime");

function AnimatedNotificationCount(props) {
  let count = props.count;
  let match = React.useState(() => false);
  let setAnimate = match[1];
  let match$1 = React.useState(() => 0);
  let setCycle = match$1[1];
  let prevRef = React.useRef(count);
  let timeoutRef = React.useRef(undefined);
  React.useEffect(() => {
    let prev = prevRef.current;
    if (count > prev) {
      let id = timeoutRef.current;
      if (id !== undefined) {
        clearTimeout(Primitive_option.valFromOption(id));
      }
      setAnimate(param => false);
      requestAnimationFrame(param => {
        setAnimate(param => true);
        setCycle(c => c + 1 | 0);
        let id = setTimeout(() => setAnimate(param => false), 2000);
        timeoutRef.current = Primitive_option.some(id);
      });
    }
    prevRef.current = count;
  }, [count]);
  React.useEffect(() => (() => {
    let id = timeoutRef.current;
    if (id !== undefined) {
      clearTimeout(Primitive_option.valFromOption(id));
      return;
    }
  }), []);
  return JsxRuntime.jsx(NotificationCount.make, {
    count: count,
    animate: match[0],
    isOpened: props.isOpened
  }, match$1[0].toString());
}

let make = AnimatedNotificationCount;

exports.make = make;
/* react Not a pure module */
